import { toast } from "sonner";
import request from "../../helpers/request";

interface IParamsGetAuditoria {
  data?: string;
  tipo?: "excecoes" | "auditoria";
  busca?: string;
  pagina?: number;
  itensPorPagina?: number;
}

const buscarLogsAuditoria = async (params?: IParamsGetAuditoria) => {
  const tipo = params?.tipo ?? "excecoes";
  let url = `${process.env.REACT_APP_API}/admin/logs/${tipo}`;

  const query = new URLSearchParams();

  if (params?.data) {
    query.append("data", params.data.replace(/[-/]/g, ""));
  }
  if (params?.busca) {
    query.append("busca", params.busca);
  }
  query.append("pagina", String(params?.pagina ?? 1));
  query.append("itensPorPagina", String(params?.itensPorPagina ?? 20));

  const queryString = query.toString();
  if (queryString) {
    url += `?${queryString}`;
  }

  const result = await request({ url, method: "GET" });

  if (result.status === 200) {
    return result;
  } else {
    toast.error("Falha ao carregar os logs");
    throw new Error("Erro ao obter logs");
  }
};

export default buscarLogsAuditoria;
